/*
 * serializeAll() adapted from serializeArray source, but doesn't exclude
 * disabled elements
 */
(function ($) {
  var r20 = /%20/g,
    rbracket = /\[\]$/,
    rCRLF = /\r?\n/g,
    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
    rsubmittable = /^(?:input|select|textarea|keygen)/i,
    rcheckableType = /^(?:checkbox|radio)$/i

  $.fn.serializeAll = function () {
    return this.map(function() {
      // Can add propHook for "elements" to filter or add form elements
      var elements = jQuery.prop( this, "elements" )
      return elements ? jQuery.makeArray( elements ) : this
    })
      .filter(function() {
        var type = this.type

        return this.name &&
        rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
        ( this.checked || !rcheckableType.test( type ) )
      })
      .map(function( i, elem ) {
        var val = jQuery( this ).val()

        return val == null ?
          null :
          jQuery.isArray( val ) ?
            jQuery.map( val, function( val ) {
              return { name: elem.name, value: val.replace( rCRLF, "\r\n" ), disabled: jquery( elem ).is( ":disabled" ) }
            }) :
            { name: elem.name, value: val.replace( rCRLF, "\r\n" ), disabled: jQuery( elem ).is( ":disabled" ) }
      }).get()
  }
})(jQuery)
